import React from "react";
import { useHardwareBackHandler } from "../../navigation/HardwareBackContext";

export function WhatsNewPresenter({
  payload,
  onClose,
  onStartTour,
  showStartTour = true,
  allowClose = true,
  allowHardwareBackDismiss = true,
}) {
  useHardwareBackHandler(() => {
    if (!allowHardwareBackDismiss) {
      return true;
    }

    onClose?.();
    return true;
  }, true);

  if (!payload) {
    return null;
  }

  const { meta, bundles } = payload;

  return (
    <div
      className="pep-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="pep-whats-new-title"
    >
      <div className="pep-panel pep-panel--wide">
        <div className="pep-panel__header">
          <p className="pep-panel__eyebrow">What&apos;s New</p>
          <h2 id="pep-whats-new-title" className="pep-panel__title">
            {meta?.title || "CrewPilot Updates"}
          </h2>
          {meta?.description ? (
            <p className="pep-panel__subtitle">{meta.description}</p>
          ) : null}
        </div>

        {bundles.map((bundle) => (
          <section key={bundle.id} className="pep-whats-new__bundle">
            <h3 className="pep-whats-new__bundle-title">{bundle.title}</h3>
            {bundle.description ? (
              <p className="pep-whats-new__bundle-desc">{bundle.description}</p>
            ) : null}
            {bundle.features.map((feature) => (
              <article key={feature.id} className="pep-whats-new__feature">
                <h4 className="pep-whats-new__feature-title">{feature.title}</h4>
                <p className="pep-whats-new__feature-desc">{feature.description}</p>
              </article>
            ))}
          </section>
        ))}

        <div className="pep-panel__actions">
          {showStartTour && onStartTour ? (
            <button type="button" className="pep-btn pep-btn--primary" onClick={onStartTour}>
              Start tour
            </button>
          ) : null}
          {allowClose ? (
            <button type="button" className="pep-btn pep-btn--secondary" onClick={onClose}>
              Close
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
